module.exports = __webpack_public_path__ + "img/appltCourse-img24.6f134e11.png";